










































































import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export default class About extends Vue {
  @Getter('currentTheme') private getterTheme!: Theme
  @Getter('currentLang') private getterLang!: Language

  private baseUrl = 'https://www.emqx.com'
  private utm = '?utm_source=emqx.io&utm_medium=referral&utm_campaign='
  private version = `${process.env.VUE_APP_VERSION}`

  get fullYear(): number {
    return new Date().getFullYear()
  }

  get mqttxLogoSrc(): string {
    if (this.getterTheme === 'light') {
      return require('@/assets/images/mqttx-dark.png')
    }
    return require('@/assets/images/mqttx-light.png')
  }

  get emqLogoSrc(): string {
    if (this.getterTheme === 'light') {
      return require('@/assets/images/emq-logo-dark.png')
    }
    return require('@/assets/images/emq-logo-light.png')
  }

  get emqWebsite(): string {
    const lang = this.getterLang === 'zh' ? 'zh' : 'en'
    return `${this.baseUrl}/${lang}${this.utm}mqttx-web-to-homepage`
  }

  get emqxCloudWebsite(): string {
    const lang = this.getterLang === 'zh' ? 'zh' : 'en'
    return `${this.baseUrl}/${lang}/cloud${this.utm}mqttx-web-to-cloud`
  }

  get emqxIoWebsite(): string {
    const baseUrl = 'https://www.emqx.io/'
    const lang = this.getterLang === 'zh' ? 'zh' : 'en'
    if (lang === 'zh') {
      return `${baseUrl}zh${this.utm}mqttx-web-to-broker`
    }
    return `${baseUrl}${this.utm}mqttx-web-to-broker`
  }

  get mqttxWebsite(): string {
    const link = 'https://mqttx.app'
    return this.getterLang === 'zh' ? `${link}/zh` : link
  }

  get releasesLink(): string {
    return `${this.mqttxWebsite}/changelogs/v${this.version}`
  }

  private goToLink(url: string) {
    const windowUrl = window.open(url)
    if (windowUrl) {
      windowUrl.opener = null
    }
  }
}
